export default {
  id: 'push_custom',
  title: 'Custom message',
  type: 'Direct',
  canSendToChannel: false,
  description: 'Send any message, opens the app to the dashboard.',
  body: {
    blocks: [
      {
        text: {
          text: '[[INPUT_MESSAGE_TEXT]]',
          type: 'mrkdwn'
        },
        type: 'section'
      }
    ]
  },
  inputs: {
    INPUT_MESSAGE_TEXT: {
      label: 'Message',
      placeholder: 'Hi {{FIRST_NAME}}, …',
      defaultValue: 'Hi {{FIRST_NAME}}, …',
      type: 'HTML'
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/push/custom.js